module.exports = __webpack_public_path__ + "static/media/addNewUser.0598e41a.svg";